

// @ngInject
function angularDataConfig(DSProvider, ENV) {
    DSProvider.defaults.basePath = ENV.BASE_PATH;
    DSProvider.defaults.rms2Path = ENV.RMS2_BASE_PATH;
    DSProvider.defaults.ENV = ENV;
}

// @ngInject
function httpProviderConfig($httpProvider) {
    $httpProvider.interceptors.push('httpInterceptor');
}

// @ngInject
function httpInterceptor($injector,$q) {
    return {
        responseError: function(rejection) {
            var AuthService = $injector.get('AuthService');
            var ToasterService = $injector.get('ToasterService');
            var $translate = $injector.get('$translate');
            if (rejection.status === 401) {
                AuthService.logOut();
            } else if (rejection.status === 403) {
                ToasterService.showError($translate.instant('errors.notallowed'));
            }
            return $q.reject(rejection);
        }
    };
}

// @ngInject
function translationConfig($translateProvider) {
    $translateProvider.translations('en', {
        'common.error': 'Error',
        'login.tenant': 'Company',
        'common.login': 'Log in',
        'login.header': 'Sign In',
        'login.password': 'Password',
        'login.title': 'Login',
        'login.username': 'Username',
        'common.resetPasswordQuestion': 'Reset password?',
        'user.resetPasswordTitle': 'Reset password',
        'user.resetPasswordInstruction': 'Please enter your company name, and username or email address. If your email address is in the system you will receive an email with a security code that you will use in the next step. If you haven\'t saved an email address you will need to contact support.',
        'common.errorMissingInputOrTenant': 'Please enter both company and username/email.',
        'common.errorEmailNotValid': 'Email address not a valid format.',
        'address.usernameOrEmail': 'Username or email address',
        'user.resetPassword': 'Reset password',
        'user.resetPasswordConfirmInstruction': 'Copy the security code that was sent to you in the email and enter a new password. Confirm the new password and click on Save new password.',
        'login.securityCode': 'Security code',
        'login.newPassword': 'New password',
        'login.confirmPassword': 'Confirm password',
        'user.confirmNewPassword': 'Save new password',
        'common.errorMissingPasswordOrConfirmation': 'Please enter both password and confirmation.',
        'common.errorPasswordsNotMatching': 'Passwords do not match.',
        'common.errorMissingSecurityCode': 'Please enter the security code from the email.',
        'user.resetPasswordFinalInstruction': 'Password saved. You can close the popup and log in.'
    });
    $translateProvider.translations('se', {
        'common.error': 'Ett fel uppstod',
        'login.tenant': 'Företag',
        'common.login': 'Logga in',
        'login.header': 'Logga in',
        'login.password': 'Lösenord',
        'login.title': 'Inloggning',
        'login.username': 'Användarnamn',
        'common.resetPasswordQuestion': 'Återställ lösenord?',
        'user.resetPasswordTitle': 'Återställ lösenord',
        'user.resetPasswordInstruction': 'Fyll i företagsnamn, och användarnamn eller epostadress. Om din epostadressen finns i systemet kommer du få en kod via epost som du använder i nästa steg. Har du inte sparat en epostadress på ditt konto behöver du kontakta support.',
        'common.errorMissingEmailOrTenant': 'Var god fyll i både företag och användarnamn/epostadress.',
        'common.errorEmailNotValid': 'Epostadressen är inte giltig.',
        'address.usernameOrEmail': 'Användarnamn eller epostadress',
        'user.resetPassword': 'Återställ lösenord',
        'user.resetPasswordConfirmInstruction': 'Kopiera in koden som skickades till dig i epostmeddelande och fyll i ett nytt lösenord. Bekräfta det nya lösenordet och klicka på Spara nytt lösenord.',
        'login.securityCode': 'Säkerhetskod',
        'login.newPassword': 'Nytt lösenord',
        'login.confirmPassword': 'Bekräfta lösenord',
        'user.confirmNewPassword': 'Spara nytt lösenord',
        'common.errorMissingPasswordOrConfirmation': 'Var god fyll i både lösenord och lösenordsbekräftelse.',
        'common.errorPasswordsNotMatching': 'Lösenorden stämmer inte överens.',
        'common.errorMissingSecurityCode': 'Var god fyll i säkerhetskoden.',
        'user.resetPasswordFinalInstruction': 'Lösenordet sparat. Du kan stänga popupen och logga in som vanligt.'
    });
    $translateProvider.useSanitizeValueStrategy('escaped');
    $translateProvider.useLocalStorage();
    $translateProvider.useUrlLoader('/api/localization/resources');
    $translateProvider.preferredLanguage('se');
    $translateProvider.fallbackLanguage('en');
}

angular.module('constant', []).constant('ENV', {
    BASE_PATH: process.env.BASE_PATH,
    NAME: process.env.NAME,
    FLEXMONSTER_KEY: process.env.FLEXMONSTER_KEY,
    RMS2_BASE_PATH: process.env.RMS2_BASE_PATH,
});

angular
    .module('core.config', [])
    .factory('httpInterceptor',httpInterceptor)
    .config(httpProviderConfig)
    .config(angularDataConfig)
    .config(translationConfig);
